module.exports = __webpack_public_path__ + "img/thumbnail_HighlandCattle_m_normal.5e5b8adc.png";